const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { MomentSold } from './MomentSold';
import * as telegram from "./telegram"
import * as utils from "./utils"
import { Account } from './Account';

export type sortOrderTypes = 'SoldPrice_DESC' | 'SoldPrice_ASC' | 'SoldDate_DESC' | 'SoldDate_ASC'  | 'Speed_DESC' | 'Speed_ASC'

export class MomentSoldFF extends MomentSold {
  public speedInSec: number = null
 
  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)

    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

  // client only
  public getSpeedClass(): string {
    if (this.speedInSec < 20) return 'superfast'
    if (this.speedInSec < 25) return 'veryfast'
    if (this.speedInSec < 30) return 'fast'
    return 'kindafast'
  }

}

(async () => {
})();
